import { SEOHead } from "@/components/seo-head";
import { AuthEntryPage } from "@/pages/login";

/** A signup-only presentation of the existing registration flow. */
export default function SignupPage() {
  return (
    <>
      <SEOHead
        title="Start your free trial | The Proper Tool"
        description="Create your account and try Smart Auto Quoting. No card needed."
        canonical="/signup"
        noIndex
      />
      <AuthEntryPage signupOnly />
    </>
  );
}
